<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" lastTitle="Seller FAQ"/>
    <div class="docs">
      <h1>Amazon Attribution Link</h1>
      <h2>What is the Attribution link?</h2>
      <p>
        An Amazon Attribution link is a tracking URL that helps advertisers
        understand how their non-Amazon marketing impacts sales on Amazon. These
        links can be used in social media posts, emails, and other media.
      </p>
      <h2>How does Attribution Link work?</h2>
      <p>
        When a user clicks on an Amazon Attribution link, Amazon tracks what
        they do on the Amazon site This information is used to measure the
        impact of marketing campaigns. Advertisers can use this information to
        improve their marketing strategies.
      </p>
      <p>ArtemisAds.com is built on Amazon Attribution Links.</p>
      <ul>
        <li>
          Sellers pay commissions for the sales generated and tracked by the
          Attribution Links
        </li>
        <li>
          Publishers/Creators are also paid against the sales generated and
          tracked by the Attribution Links
        </li>
      </ul>

      <h2>Who can use Attribution Link?</h2>
      <p>
        Amazon Attribution is available to professional seller brand owners
        enrolled in Amazon Brand Registry. It's also available to vendors that
        sell products on Amazon in certain markets
      </p>
      <h2>How to set up Attribution Link?</h2>
      <p>
        After you sign up as a publisher or creator at ArtemisAds.com
        successfully, you may:
      </p>
      <ul>
        <li>
          View sellers’ products and generate Amazon Attribution links to
          promote.
        </li>
        <li>
          You may also apply for ArtemisAds.com’s API, and generate Amazon
          Attribution links in bulk.
        </li>
      </ul>
      <h2>Can I combine Amazon Attribution Link with Amazon Associate Link?</h2>
      <p>No.</p>
      <p>
        You should not combine Amazon Attribution links with Amazon Associates
        links.
      </p>
      <p>
        Amazon's policy prohibits using the same traffic to earn commissions
        from multiple programs.
      </p>
      <p>
        Amazon may take action against those who try to claim commissions from
        both Amazon Associates and another program using the same traffic.
      </p>
      <p>
        This includes manipulating or combining attribution links. Amazon may
        withhold commissions or terminate participation in the Associates
        program.
      </p>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
</script>